export enum AutoCommentGroupEnum {
    Confidence = 1,
    Attendance = 2,
    Vocabulary = 3,
    Grammar = 4,
    Pronunciation = 5,
    Advices = 6,
    Ending = 7
}